import React, {useEffect, useState} from 'react';
import {Table, Button, Popconfirm, Switch, Form, Input, DatePicker, Select, message} from 'antd';
import axios from "axios";
import moment from "moment";
import {API_URI, TOKENADMIN} from "../../constants/ApiConfig";

const {RangePicker} = DatePicker;
const {Option} = Select;

const DatesIndisponiblesManager = ({idSejour = null, idPays = null}) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();


    const fetchData = async () => {
        setLoading(true);
        try {
            let filter = '';
            if (idPays) filter += `paysSejour=${idPays}`;
            if (idSejour) filter += (filter ? '&' : '') + `sejour=${idSejour}`;

            const res = await axios.get(`${API_URI}/api/dates_indisponibles?${filter}`, {
                headers: {Authorization: 'bearer ' + TOKENADMIN}
            });

            const filtered = res.data['hydra:member'];
            setData(filtered);
        } catch (e) {
            message.error("Erreur lors du chargement");
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, [idSejour, idPays]);

    const handleDelete = async (id) => {
        await axios.delete(`${API_URI}/api/dates_indisponibles/${id}`, {
            headers: {Authorization: 'bearer ' + TOKENADMIN}
        });
        message.success("Supprimé !");
        fetchData();
    };

    const toggleActif = async (id, actif) => {
        await axios.patch(`${API_URI}/api/dates_indisponibles/${id}`, {actif}, {
            headers: {
                'Authorization': 'bearer ' + TOKENADMIN,
                'Content-Type': 'application/merge-patch+json'
            }
        });
        message.success("Mis à jour");
        fetchData();
    };

    const onFinish = async (values) => {
        const [debut, fin] = values.periode;
        const payload = {
            debut: debut.format(),
            fin: fin.format(),
            actif: true,
            supprimer: false,
            sejour: idSejour ? parseInt(idSejour) : null,
            paysSejour: idPays ? parseInt(idPays) : null,
            cat: null
        };

        await axios.post(`${API_URI}/api/dates_indisponibles`, payload, {
            headers: {Authorization: 'bearer ' + TOKENADMIN}
        });
        message.success("Ajoutée !");
        form.resetFields();
        fetchData();
    };

    const columns = [
        {
            title: 'Début',
            dataIndex: 'debut',
            render: d => moment(d).format('DD/MM/YYYY')
        },
        {
            title: 'Fin',
            dataIndex: 'fin',
            render: d => moment(d).format('DD/MM/YYYY')
        },
        {
            title: 'Actif',
            dataIndex: 'actif',
            render: (actif, record) => (
                <Switch checked={actif} onChange={(val) => toggleActif(record.id, val)}/>
            )
        },
        {
            title: 'Actions',
            render: (_, record) => (
                <Popconfirm title="Supprimer ?" onConfirm={() => handleDelete(record.id)}>
                    <Button danger>Supprimer</Button>
                </Popconfirm>
            )
        }
    ];

    return (
        <>
            <Form form={form} layout="inline" onFinish={onFinish} style={{marginBottom: 16}}>
                <Form.Item name="periode" rules={[{required: true, message: "Choisir une période"}]}>
                    <RangePicker/>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">Ajouter</Button>
                </Form.Item>
            </Form>

            <Table
                rowKey="id"
                dataSource={data}
                columns={columns}
                loading={loading}
                pagination={false}
            />
        </>
    );
};

export default DatesIndisponiblesManager;
